import { Config } from "../../../utils/config";
const mediaSelectorPrefix = "@media";
export const hasPhrase = ({ element, phrase, exceptionalSlug, isComplexSlug }) => {
  const extractedPhrase = getSlugFromId(element == null ? void 0 : element.id, isComplexSlug);
  if (extractedPhrase == null ? void 0 : extractedPhrase.includes(exceptionalSlug)) {
    const elementIndex = extractedPhrase.split("_").pop();
    const extractedNestedPhrase = `${exceptionalSlug}_${elementIndex}`;
    return extractedPhrase === extractedNestedPhrase;
  } else {
    return phrase === extractedPhrase;
  }
};
export const getCleanFormElementId = (formElementId) => {
  const regex = /^([a-zA-Z0-9_]+)(?:\[[a-zA-Z0-9_]+\])?(?:\[\])?$/;
  const match = formElementId.match(regex);
  const cleanSlugIndex = 1;
  return (match == null ? void 0 : match[cleanSlugIndex]) || "";
};
export const getSlugFromId = (id, isComplexSlug) => {
  const parts = id.split("_");
  parts.pop();
  if (isComplexSlug) parts.pop();
  return parts.join("_");
};
export const kebabToCamelCaseProperties = (obj) => {
  const _camelCaseKey = (key) => {
    if (key.includes("--")) {
      return key;
    }
    return key.replace(/-([a-z])/g, (match, p1) => p1.toUpperCase());
  };
  const _setFormattedProperty = (newObj2, selector, selectorStyles) => {
    newObj2[selector] = {};
    for (let prop in selectorStyles) {
      newObj2[selector][_camelCaseKey(prop)] = selectorStyles[prop];
    }
  };
  let newObj = {};
  for (let selector in obj) {
    const selectorStyles = obj[selector];
    if (selector.includes(mediaSelectorPrefix)) {
      newObj[selector] = {};
      for (let nestedSelector in selectorStyles) {
        _setFormattedProperty(newObj[selector], nestedSelector, selectorStyles[nestedSelector]);
      }
    } else {
      _setFormattedProperty(newObj, selector, selectorStyles);
    }
  }
  return newObj;
};
const hasNestedObject = (obj) => {
  if (typeof obj !== "object") return;
  return Object.values(obj).some((value) => typeof value === "object" && value !== null && !Array.isArray(value));
};
export function objectToCss(styles) {
  let cssString = "";
  const _addProperty = (numberOfSpaces = 0, selectorStyles) => {
    var _a;
    let spaces = "";
    for (let i = 0; i < numberOfSpaces; i++) {
      spaces += " ";
    }
    for (const property in selectorStyles) {
      const value = (_a = selectorStyles[property]) == null ? void 0 : _a.toString();
      if (value) {
        const kebabProperty = property.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
        cssString += `${spaces}${kebabProperty}: ${value};
`;
      }
    }
  };
  for (const selector in styles) {
    cssString += `${selector} {
`;
    const selectorStyles = styles[selector];
    if (hasNestedObject(selectorStyles)) {
      for (const nestedSelector in selectorStyles) {
        cssString += `  ${nestedSelector} {
`;
        const numberOfSpacesForNestedProperty = 4;
        _addProperty(numberOfSpacesForNestedProperty, selectorStyles[nestedSelector]);
        cssString += "  }\n";
      }
    } else {
      const numberOfSpacesForProperty = 2;
      _addProperty(numberOfSpacesForProperty, selectorStyles);
    }
    cssString += "}\n";
  }
  return cssString;
}
export const getCurrentFormLanguage = (language, translations = {}) => {
  const firstExistingLanguage = Object.keys(translations)[0];
  return language ? (
    // our default form language is 'en_US' and since 'en-US' and 'en_US'
    // are two different languages we have to make this exception here
    language.toLowerCase() === "en-us" ? language : (
      //we want to keep '-' in html so we need to malform it to _ for i18next
      language.replace("-", "_")
    )
  ) : firstExistingLanguage ? firstExistingLanguage : Config.language.defaultLanguage;
};
export const checkValuesEquality = (valueX, valueY) => {
  return valueX && valueY && typeof valueX === "object" && typeof valueY === "object" ? Object.keys(valueX).length === Object.keys(valueY).length && Object.keys(valueX).every((key) => checkValuesEquality(valueX[key], valueY[key])) : valueX === valueY;
};
